import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useDonationsStore } from '../store/donationsStore'
import { verifyDonation } from '../utils/verifyDonation'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useVerifyDonationMutation = (onSuccess?: () => void) => {
  const update = useDonationsStore((state) => state.update)

  return useMutation({
    mutationFn: verifyDonation,
    onSuccess: ({ message, donation }) => {
      update(donation)

      toast.success(message || 'Donation verified successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while verifing donation.')
    },
  })
}
